import { FormattedMessage as FM } from "react-intl";

import { formatInheritedValue } from "../helpers/hotelDefaults";
import { COLOR_FIELDS } from "../constants";

function InheritedRow({ name, value }) {
  const text = formatInheritedValue(name, value);
  return (
    <li className="flex items-center justify-between gap-3 py-1.5 text-sm">
      <span className="shrink-0 text-neutral-500">
        <FM id={`melhous.${name}`} />
      </span>
      <span className="flex min-w-0 items-center gap-2 text-neutral-800">
        {COLOR_FIELDS.includes(name) && (
          <span
            className="size-4 shrink-0 rounded border border-neutral-300"
            style={{ backgroundColor: text }}
          />
        )}
        <span className="truncate" title={text}>
          {text}
        </span>
      </span>
    </li>
  );
}

export default InheritedRow;
